<template lang="pug">
  .authorization
    .authorization__title Регистрация
    //- .authorization__title--text Добро пожаловать! Войдите в свой аккаунт чтобы оставлять заявки в лагеря
    .authorization__form.authorization__form_entry
      form(
        @submit.prevent="onSubmitMethod"
      )
        .auth-form
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.email }"
            )
              //- form-elem_error
              .form-elem__title Email
              .form-elem__body
                input.input.input_full(
                  type="email"
                  v-model="userCredentials.email"
                  placeholder="example@mail.ru"
                  @keyup="keymonitor"
                )
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.password }"
            )
              .form-elem__title Пароль
              .form-elem__body
                input.input.input_full(
                  type="password"
                  v-model="userCredentials.password"
                  @keyup="keymonitor"
                )
              .form-elem__description Пароль должен содержать не менее 8 символов, включающих в себя буквы разного регистра и цифры.
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.password2 }"
            )
              .form-elem__title Пароль еще раз
              .form-elem__body
                input.input.input_full(
                  type="password"
                  v-model="userCredentials.password2"
                  @keyup="keymonitor"
                )
          .auth-form__elem
            .form-elem
              .form-elem__body
                .input-item(
                  :class="{ 'input-item_error' : userCredentialErrors.consentModel }"
                )
                  .input-item__input
                    label.checkbox
                      input.checkbox__input(
                        type="checkbox"
                        v-model="consentModel"
                        @change="keymonitor"
                      )
                      .checkbox__icon
                  .input-item__body
                    .input-item__text Даю свое согласие на&#32;
                      a(
                        href="/documents/ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ  РЦ ЛЕТО.docx"
                        target="_blank"
                      ).link обработку персональных данных согласно ФЗ-152
          .auth-form__elem
            .form-elem(
              :class="{ 'form-elem_error': userCredentialErrors.recaptcha }"
            )
              .form-elem__body
                .recaptcha
                  .recaptcha__container
                    vue-recaptcha(
                      sitekey='6LdA01UUAAAAAFvkoOYGnd4h7MYWtTiEyYxBBC02'
                      ref='recaptcha'
                      @expired="onExpiredRecapcha"
                      @verify="onVerifyRecapcha"
                    ).recaptcha__elem
              .form-elem__error(
                v-if="userCredentialErrors.recaptcha"
              ) Подтвердите, что вы не робот
          .auth-form__elem.auth-form__elem_button
            .form-elem
              .form-elem__body
                button.button.button_paint-main.button_full(
                  :class="{ 'loaded-button': pending }"
                  @click="onReg()"
                ) Зарегистрироваться
                .form-elem__error(
                  v-if="msgError.length > 0"
                ) {{ msgError }}
          .auth-form__elem
            .form-elem
              .form-elem__body
                .link(
                  @click="$emit('onChangeModalType', 'sign_in')"
                ) Вход на сайт
</template>

<script>
import {mapActions} from "vuex";
import jsMd5 from "js-md5";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "SignUp",
  components: {
    VueRecaptcha
  },
  props: {},
  data() {
    return {
      pending: false,
      consentModel: false,
      userCredentials: {
        // nikitos@email.com
        // aA123321
        email: "",
        password: "",
        password2: "",
        recaptcha: ""
      },
      userCredentialErrors: {
        email: false,
        password: false,
        password2: false,
        consentModel: false,
        recaptcha: false
      },
      msgError: "",
      errorMsg: {
        password: "Пароли не совпадают",
        short_password: "Пароль должен содержать минимум 8 символов",
        easy_password: "Пароль слишком простой",
        server: "Данный пользователь уже существует",
        email: "Неверный формат email",
        consentModel: "Необходимо согласие"
      }
    };
  },
  methods: {
    ...mapActions(["reg"]),
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    keymonitor() {
      this.userCredentialErrors = {
        email: false,
        password: false,
        password2: false,
        consentModel: false,
        recaptcha: false
      };
      this.msgError = "";
    },
    onReg() {
      this.pending = true;
      const errors = [];
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.userCredentials.email.length === 0 ||
        !reg.test(this.userCredentials.email)
      ) {
        errors.push("email");
        this.msgError = this.errorMsg.email;
      }
      if (this.userCredentials.password.length === 0) {
        errors.push("password");
      }
      if (this.userCredentials.password2.length === 0) {
        errors.push("password2");
      }
      if (!this.consentModel) {
        errors.push("consentModel");
      }
      if (this.userCredentials.password !== this.userCredentials.password2) {
        errors.push("password");
      }
      if (this.userCredentials.recaptcha.length === 0) {
        errors.push("recaptcha");
      }
      if (errors.length > 0) {
        this.pending = false;
        errors.map(el => {
          this.userCredentialErrors[el] = true;
        });
        if (
          this.userCredentials.password !== this.userCredentials.password2 &&
          this.msgError.length === 0
        ) {
          this.msgError = this.errorMsg.password;
        }
        return;
      }
      if (this.userCredentials.password.length < 8) {
        this.pending = false;
        this.msgError = this.errorMsg.short_password;
        return;
      }
      // const password_reg = /^(?=.*[a-z])(?=.*[A-Z])/;
      // if (!password_reg.test(this.userCredentials.password)) {
      //   this.msgError = this.errorMsg.easy_password;
      //   return;
      // }
      const minutes = ("0" + new Date().getMinutes()).slice(-2);
      const reverseMinutes = minutes
        .split("")
        .reverse()
        .join("");
      const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);
      this.reg({
        userCredentials: this.userCredentials,
        xAuthHash
      }).then(res => {
        this.pending = false;
        if (res.status === 400) {
          if (res.data.password) {
            this.userCredentialErrors.password = true;
            this.userCredentialErrors.password2 = true;
            this.msgError = this.errorMsg.easy_password;
            return;
          }
          this.userCredentialErrors.email = true;
          this.msgError = this.errorMsg.server;
          return;
        }
        if (res.status === 201) {
          this.$emit("onChangeModalType", "access_msg", {
            title: "Проверьте почту",
            text: `Мы выслали ссылку для подтверждения регистрации на ${
              this.userCredentials.email
            }`
          });
        }
      });
    },
    onSubmitMethod(e) {
      e.preventDefault();
    },
    onVerifyRecapcha(response) {
      this.userCredentials.recaptcha = response;
      this.userCredentialErrors.recaptcha = false;
    },
    onExpiredRecapcha() {
      this.userCredentials.recaptcha = "";
    },
    onResize() {
      const recap = this.$refs.recaptcha.$el;
      const containerWidth = recap.parentElement.offsetWidth;
      const recapWidth = recap.offsetWidth;
      const recapHeight = recap.offsetHeight;
      if (recapWidth > containerWidth) {
        const recapScale = containerWidth / recapWidth;
        recap.style.transform = "scale(" + recapScale + ")";
        recap.parentElement.style.height =
          recap.offsetHeight * recapScale + "px";
      } else {
        recap.style.transform = "scale(1)";
        recap.parentElement.style.height = recapHeight + "px";
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>
